import script from "./web-news-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./web-news-detail.vue?vue&type=script&setup=true&lang=js"

import "./web-news-detail.vue?vue&type=style&index=0&id=0ad58613&lang=scss"

const __exports__ = script;

export default __exports__